// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"208":"85918ffc","410":"5192e992","584":"d2234b8f","885":"33c5e137","923":"0488fa82"}[chunkId] + ".css";
};